import {
  allapplications,
  applications,
  alljobs,
  jobs,
  profile,
  states,
} from './data';

const fetchAllApplications = async () => {
  try {
    const res = await fetch(`http://localhost:3001/api/allapplications`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (res.status !== 201) {
      return res.json();
    } else {
    }
  } catch (error) {
    //console.log(error);
    return allapplications;
  }
};

const fetchApplications = async () => {
  try {
    const res = await fetch(`http://localhost:3001/api/applications`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (res.status !== 201) {
      return res.json();
    } else {
    }
  } catch (error) {
    //console.log(error);
    return applications;
  }
};

const fetchAllJobs = async () => {
  try {
    const res = await fetch(`http://localhost:3001/api/alljobs`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (res.status !== 201) {
      return res.json();
    } else {
    }
  } catch (error) {
    //console.log(error);
    return alljobs;
  }
};
const fetchJobs = async () => {
  try {
    const res = await fetch(`http://localhost:3001/api/jobs`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (res.status !== 201) {
      return res.json();
    } else {
    }
  } catch (error) {
    //console.log(error);
    return jobs;
  }
};
const fetchAllLocations = async () => {
  console.count('fetchAllLocations');
  try {
    const res = await fetch(`http://localhost:3001/api/locations`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (res.status !== 201) {
      return res.json();
    } else {
    }
  } catch (error) {
    //console.log(error);
    return states;
  }
};
const fetchProfile = async () => {
  try {
    const res = await fetch(`http://localhost:3001/api/profile`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (res.status !== 201) {
      return res.json();
    } else {
    }
  } catch (error) {
    //console.log(error);
    return profile;
  }
};

export {
  fetchAllApplications,
  fetchAllJobs,
  fetchAllLocations,
  fetchApplications,
  fetchJobs,
  fetchProfile,
};
